export const CONN_PREFIX = 'CONNECT_';